import { MasterData } from 'models/MasterDataDto';

export const excludeInvalidClients = (client: MasterData): boolean => client.code !== 'A00000000';
